import respuestasFalsas from "../views/registro/RespuestasFalsas";

const getRandom = (array) => {
    const op1 = Math.floor(Math.random() * array.length);
    const op2 = Math.floor(Math.random() * array.length);
    const op3 = Math.floor(Math.random() * array.length);
    return array.filter((o, index) => index === op1 || index === op2 || index === op3)
} 

export const getRespuestasFalsasDomicilio = () => {
    return getRandom(respuestasFalsas.direccion)
};
  
export const getRespuestasFalsasPlanes = () => {
    return getRandom(respuestasFalsas.plan)
};

export const getRespuestasFalsasNombre = () => {
    return getRandom(respuestasFalsas.apellido_nombres)
};
